import { render, staticRenderFns } from "./ReportsList.vue?vue&type=template&id=6228d9e6&scoped=true&"
import script from "./ReportsList.vue?vue&type=script&lang=js&"
export * from "./ReportsList.vue?vue&type=script&lang=js&"
import style0 from "./ReportsList.vue?vue&type=style&index=0&id=6228d9e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6228d9e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6228d9e6')) {
      api.createRecord('6228d9e6', component.options)
    } else {
      api.reload('6228d9e6', component.options)
    }
    module.hot.accept("./ReportsList.vue?vue&type=template&id=6228d9e6&scoped=true&", function () {
      api.rerender('6228d9e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stats/ReportsList.vue"
export default component.exports